export const menu = [
  {
    icon: 'bx bx-calendar',
    title: 'Lịch làm việc',
    accId: 0,
    href: '/calendar',
    permission: 'CNPS_WKCLDR_GET_LIST_TASK_BY_USERID',
  },
  {
    icon: 'bx bx-sticker',
    title: 'Ticket',
    accId: 10,
    listPermission: ['CNPS_TICKET_VIEW'],
    child: [
      {
        title: 'Ticket',
        href: '/ticket',
        permission: 'CNPS_TICKET_VIEW',
      },
      {
        title: 'Việc cần làm',
        href: '/ticket-work',
        permission: 'CNPS_TICKET_VIEW',
      },
      {
        title: 'Lịch sử hoạt động',
        href: '/ticket-history',
        permission: 'CNPS_TICKET_VIEW',
      },
      {
        title: 'Nhóm ticket',
        href: '/ticket-group',
        permission: 'CNPS_TICKET_GROUP_VIEW',
      },
      {
        title: 'Danh mục ticket',
        href: '/ticket-category',
        permission: 'CNPS_TICKET_CATEGORY_VIEW',
      },
      {
        title: 'Tiểu mục ticket',
        href: '/ticket-sub-category',
        permission: 'CNPS_TICKET_SUB_CATEGORY_VIEW',
      },
      {
        title: 'Hiện trạng ticket',
        href: '/ticket-current-state',
        permission: 'CNPS_TICKET_SUB_CATEGORY_VIEW',
      },
      {
        title: 'Bước chuyển ticket',
        href: '/ticket-transition',
        permission: 'CNPS_TICKET_TRANSITION_VIEW',
      },
    ],
  },
  {
    icon: 'bx bx-calendar',
    title: 'Lịch làm việc AFS',
    accId: 1,
    listPermission: [
      'CNPS_CALENDAR_WK_GROUP_LIST',
      'CNPS_CALENDAR_WK_TASK_LIST',
      'CNPS_CALENDAR_AFS_LIST_ON_WEB',
      'CNPS_CALENDAR_WK_LICENSE_VIEW_DATA',
      // 'PERMISSION_OUT_MYNEXTPAY',
      'CNPS_CSTM_MERCHANT_KEY_LIST',
    ],
    child: [
      {
        title: 'Nhóm công việc',
        href: '/group-calendar-afs',
        permission: 'CNPS_CALENDAR_WK_GROUP_LIST',
      },
      {
        title: 'Danh mục công việc',
        href: '/cat-calendar-afs',
        permission: 'CNPS_CALENDAR_WK_TASK_LIST',
      },
      {
        title: 'Tiểu mục công việc',
        href: '/work-subsection-afs',
        permission: 'CNPS_CSS_SUB_CATEGORY_TASK',
      },

      {
        title: 'Công việc',
        href: '/calendar-afs',
        permission: 'CNPS_CALENDAR_AFS_LIST_ON_WEB',
      },
      {
        title: 'Công việc MCK',
        href: '/customer-support/tasks',
        permission: 'CNPS_CSTM_MERCHANT_KEY_LIST',
      },
      {
        title: 'Yêu cầu chứng từ',
        href: '/list-licence',
        permission: 'CNPS_CALENDAR_WK_LICENSE_VIEW_DATA',
      },
      {
        title: 'Thanh toán T+2',
        href: '/payment-T2',
        permission: 'CNPS_CALENDAR_WK_LICENSE_VIEW_DATA',
      },
    ],
  },
  {
    icon: 'bx bx-timer',
    title: 'Chấm công',
    accId: 2,
    listPermission: ['CNPS_ATTN_ATTENDANCE_LIST', 'CNPS_ATTN_ADD_GET_ALL_WEB'],
    child: [
      {
        title: 'Điểm danh',
        href: '/attendance',
        permission: 'CNPS_ATTN_ATTENDANCE_LIST',
      },
      {
        title: 'Chấm công bổ sung',
        href: '/timekeeping',
        permission: 'CNPS_ATTN_ADD_GET_ALL_WEB',
      },
    ],
  },
  {
    icon: 'bx bx-buildings',
    title: 'Merchant',
    accId: 3,
    listPermission: [
      'CNPS_CSTM_MERCHANT_LIST',
      'CNPS_CSTM_MERCHANT_TRANSFER_HISTORY_VIEW',
      'CNPS_LEAD_VIEW',
    ],
    child: [
      {
        title: 'Danh sách Lead',
        href: '/leads',
        permission: 'CNPS_LEAD_VIEW',
      },
      {
        title: 'KH tiềm năng',
        href: '/potential-customers',
        permission: 'CNPS_CSTM_MERCHANT_POTENTIAL_LIST',
      },
      {
        title: 'Danh sách Merchant',
        href: '/list-mc',
        permission: 'CNPS_CSTM_MERCHANT_LIST',
      },
      {
        title: 'Merchant tự onboard',
        href: '/list-mc-onboard',
        permission: 'CNPS_CSTM_MERCHANT_LIST',
      },
      {
        title: 'Bản đồ điểm bán',
        href: '/map-list-mc',
        permission: 'CNPS_CSTM_VIEW_MAP',
      },
      {
        title: 'Heatmap Merchant',
        href: '/heatmap-list-mc',
        permission: 'CNPS_CSTM_VIEW_MAP',
      },
      /*
      {
        title: 'Heatmap cho Merchant',
        href: '/heatmap-mc',
        permission: 'CNPS_CSTM_VIEW_MAP'
      },
      */
      // {
      //   title: 'Điều chuyển',
      //   href: '/trans-mc',
      //   permission: 'CNPS_CSTM_MERCHANT_PRE_TRANSFER'
      // },
      {
        title: 'Điều chuyển MC',
        href: '/history-trans',
        permission: 'CNPS_CSTM_MERCHANT_TRANSFER_HISTORY_VIEW',
      },
      {
        title: 'Biểu phí ưu đãi',
        href: '/proposal-fee',
        permission: '',
      },
      {
        title: 'Danh sách vị trí thiết bị',
        href: '/device-location/list',
        permission: 'CNPS_CSTM_LOC_SERIAL_LIST',
      },
      // {
      //   title: 'Quản lý khách hàng',
      //   href: '/merchant-owner',
      //   permission: 'PERMISSION_OUT_MYNEXTPAY'
      // },
      {
        title: 'Thông tin giao hàng - Leads',
        href: '/management-shipping',
        permission: 'CNPS_LEAD_VIEW',
      },
    ],
  },
  {
    icon: 'bx bx-devices',
    title: 'Quản lý thiết bị',
    accId: 4,
    listPermission: [
      'CNPS_DEVICE_CATEGORY_VIEW',
      'CNPS_DEVICE_VIEW',
      'CNPS_DEVICE_ORDER_VIEW',
      'CNPS_DEVICE_INVENTORY_VIEW',
      'CNPS_DEVICE_REQUEST_TICKET_VIEW',
    ],
    child: [
      {
        title: 'Danh mục kho',
        href: '/cat-warehouse',
        permission: 'CNPS_DEVICE_INVENTORY_VIEW',
      },
      {
        title: 'Danh mục thiết bị',
        href: '/cat-device',
        permission: 'CNPS_DEVICE_CATEGORY_VIEW',
      },
      {
        title: 'Thiết bị',
        href: '/device',
        permission: 'CNPS_DEVICE_VIEW',
      },
      {
        title: 'Sim kèm tingbox',
        href: '/attached-sim',
        permission: 'CNPS_DEVICE_VIEW',
      },
      {
        title: 'Quản lý sim',
        href: '/management-sim',
        permission: 'SCON_SIM_MANAGE_VIEW',
      },
      {
        title: 'Thiết bị Boxme',
        href: '/device-boxme',
        permission: 'CNPS_DEVICE_BOXME_VIEW',
      },
      {
        title: 'Vật tư trạng thái',
        href: '/material/list/status',
        permission: 'CNPS_DEVICE_VIEW',
      },
      {
        title: 'Vật tư kho',
        href: '/material/list/warehouse',
        permission: 'CNPS_DEVICE_VIEW',
      },
      {
        title: 'Nhập kho',
        href: '/import-warehouse',
        permission: 'CNPS_DEVICE_ORDER_IMPORT_VIEW',
      },
      {
        title: 'Yêu cầu hoàn hàng',
        href: '/return-request',
        permission: 'CNPS_DEVICE_ORDER_RETURN_VIEW',
      },
      {
        title: 'Xuất kho',
        href: '/export-warehouse',
        permission: 'CNPS_DEVICE_ORDER_EXPORT_VIEW',
      },
      {
        title: 'Điều chuyển',
        href: '/transfer-warehouse',
        permission: 'CNPS_DEVICE_ORDER_TRANSFER_VIEW',
      },
      {
        title: 'Danh sách bàn giao thiết bị',
        href: '/equipment-handover-list',
        permission: 'CNPS_DEVICE_HANDOVER_VIEW',
      },

      {
        title: 'Phiếu bảo hành',
        href: '/warranty',
        permission: 'CNPS_DEVICE_ORDER_WARRANTY_VIEW',
      },
      {
        title: 'Loại lỗi',
        href: '/error-type',
        permission: 'CNPS_DEVICE_INFO_ERROR_VIEW',
      },
      {
        title: 'Điều chính số lượng vật tư',
        href: '/quantity-material',
        permission: 'CNPS_DEVICE_ORDER_BALANCE_VIEW',
      },
      {
        title: 'Báo cáo xuất nhập',
        href: '/report-inventory',
        permission: 'CNPS_DEVICE_REPORT_VIEW',
      },
      {
        title: 'Chuyển mục đích sử dụng',
        href: '/usage-change',
        permission: 'CNPS_DEVICE_ORDER_USAGE_CHANGE_VIEW',
      },
      {
        title: 'Danh sách thuê thiết bị',
        href: '/rent-device',
        permission: 'CNPS_DEVICE_CONTRACT_KEY_RENTAL_LIST_VIEW',
      },
      // {
      //   title: 'Danh sách mượn thiết bị',
      //   href: '/management-lend-device',
      //   permission: 'CNPS_DEVICE_LENDING_VIEW',
      // },
      {
        title: 'Danh sách mượn thiết bị',
        href: '/management-lend-device-v1',
        permission: 'CNPS_DEVICE_LENDING_VIEW',
      },
      {
        title: 'TB chờ kích hoạt',
        href: '/device-not-yet-activated',
        permission: 'CNPS_DEVICE_REQUEST_TICKET_VIEW',
      },
    ],
  },
  // {
  //   icon: 'bx bx-buildings',
  //   title: 'Quản lý Agent',
  //   accId: 4,
  //   child: [
  //     {
  //       title: 'Danh sách',
  //       href: '/agent',
  //       permission: ''
  //     }
  //   ]
  // },
  {
    icon: 'bx bx-buildings',
    title: 'Cộng tác viên & Đại lý',
    accId: 5,
    listPermission: [
      'CNPS_AGENT_LIST',
      'CNPS_CSTM_MERCHANT_CTV_VIEW',
      'CNPS_CSTM_MERCHANT_CTV_ASSIGN_VIEW',
      'CNPS_DFS_TOP_COMMISSION_POLICY_VIEW',
      'SCON_RECEIPT_AGENCY_VIEW',
      'CNPS_AGENCY_LIST',
      'CNPS_DEVICE_ORDER_TRANSFER_VIEW',
    ],
    child: [
      {
        title: 'Quản lý cộng tác viên',
        href: '/list-collaborators',
        permission: 'CNPS_AGENT_LIST',
      },
      {
        title: 'Quản lý đối tác',
        href: '/list-agent-partner',
        permission: 'CNPS_AGENT_PARTNER_BANK_LIST',
      },
      {
        title: 'Quản lý đại lý',
        href: '/list-agency',
        permission: 'CNPS_AGENCY_LIST',
      },
      {
        title: 'Phiếu thu đối tác',
        href: '/agent-receipt',
        permission: 'SCON_RECEIPT_AGENCY_VIEW',
      },
      {
        title: 'Điều chuyển đại lý',
        href: '/transfer-agency',
        permission: 'CNPS_DEVICE_ORDER_TRANSFER_VIEW',
      },
      {
        title: 'Quản lý đặt hàng',
        href: '/order-form',
        permission: 'CNPS_DEVICE_PURCHASE_ORDER_VIEW',
      },
      {
        title: 'Hoa hồng TingBox',
        href: '/list-tingbox-ctv',
        permission: 'CNPS_DFS_TOP_COMMISSION_POLICY_VIEW',
      },
      // {
      //   title: 'Hợp đồng merchant CTV',
      //   href: '/manage-mc',
      //   permission: 'CNPS_CSTM_MERCHANT_LIST'
      // },
      // {
      //   title: 'Merchant',
      //   href: '/assign-mc',
      //   permission: 'CNPS_CSTM_MERCHANT_CTV_ASSIGN_VIEW'
      // },
      // {
      //   title: 'Lịch sử gán merchant',
      //   href: '/history-assign-mc',
      //   permission: 'CNPS_CSTM_MERCHANT_CTV_ASSIGN_VIEW'
      // },
      // {
      //   title: 'Lịch sử chi hoa hồng',
      //   href: '/history-comissions',
      //   permission: ''
      // }
    ],
  },
  {
    icon: 'bx bx-user-circle',
    title: 'Nhân viên',
    accId: 6,
    href: '/staff',
    permission: 'CNPS_SUR_STAFF_LIST',
  },
  {
    icon: 'bx bx-notepad',
    title: 'Hợp đồng',
    accId: 7,
    listPermission: [
      'CNPS_SCON_LIST',
      'CNPS_SCON_LIST_SELL',
      'CNPS_SCON_LIST_PAYMENT',
      'CNPS_WKCLDR_STICKER_IMAGE_GPDKKD',
      'CNPS_CALENDAR_WK_STANDEE_STICKER_IMAGE',
      'CNPS_CSTM_NEED_BUSINESS_REG_LIST',
      'CNPS_SCON_MEGABIZ_LIST',
      'CNPS_AGENT_COMBO_REGISTRATION_REQUEST_VIEW',
    ],
    child: [
      {
        title: 'Danh sách hợp đồng',
        href: '/contract-manager',
        permission: 'CNPS_SCON_LIST',
      },
      {
        title: 'Hợp đồng Ngân Lượng',
        href: '/contract-nganluong',
        permission: 'CNPS_SCON_LIST',
      },
      {
        title: 'Danh sách phụ lục phí VISA',
        href: '/appendix-fee-visa',
        permission: 'CNPS_SCON_LIST',
      },
      {
        title: 'Dánh sách hợp đồng Megabiz',
        href: '/contract-megabiz',
        permission: 'CNPS_SCON_MEGABIZ_LIST',
      },

      {
        title: 'Hợp đồng bán hàng',
        href: '/contract-manager?groupService=SELL',
        permission: 'CNPS_SCON_LIST_SELL',
      },
      {
        title: 'Hợp đồng thanh toán',
        href: '/contract-manager?groupService=PAYMENT',
        permission: 'CNPS_SCON_LIST_PAYMENT',
      },
      {
        title: 'Phụ lục hợp đồng ký thêm',
        href: '/appendix-manager',
        permission: 'CNPS_SCON_LIST', // fix
      },
      {
        title: 'Công việc bổ sung GP ĐKKD',
        href: '/gpdkkd',
        permission: [
          'CNPS_WKCLDR_STICKER_IMAGE_GPDKKD',
          'CNPS_CALENDAR_WK_STANDEE_STICKER_IMAGE',
          'CNPS_CSTM_NEED_BUSINESS_REG_LIST',
        ],
      },
      {
        title: 'Đăng ký MC ưu đãi',
        href: '/preferential-merchant-registration',
        permission: 'CNPS_SCON_LIST',
      },
      {
        title: 'Quản lý HĐ/PL giấy',
        href: '/paper-contract-manager',
        permission: 'CNPS_SCON_LIST',
      },
      {
        title: 'Thay đổi thông tin',
        href: '/info-change',
        permission: 'CNPS_SCON_LIST',
      },
      {
        title: 'Đối soát CT TK BIDV',
        href: '/mc-bidv',
        permission: 'SCON_RECONCILIATION_MANAGEMENT_VIEW',
      },
      {
        title: 'Danh sách đề xuất phí',
        href: '/proposed-fees',
        permission: 'CNPS_SCON_APPENDIX_LIST_PRICE_PROPOSAL',
      },
      {
        title: 'Yêu cầu combo bán hàng',
        href: '/request-sales-combo',
        permission: 'CNPS_AGENT_COMBO_REGISTRATION_REQUEST_VIEW',
      },
    ],
  },
  {
    icon: 'bx bx-receipt',
    title: 'Phiếu thu',
    accId: 8,
    listPermission: ['SCON_RECEIPT_VIEW', 'CNPS_SCON_REFUND_VIEW', 'CNPS_SCON_ORDER_PAYMENT_VIEW'],
    child: [
      {
        title: 'Danh sách phiếu thu',
        href: '/list-receipts',
        permission: 'SCON_RECEIPT_VIEW',
      },
      {
        title: 'Danh sách yêu cầu hoàn tiền',
        href: '/list-refund',
        permission: 'CNPS_SCON_REFUND_VIEW',
      },
      {
        title: 'Danh sách đề nghị thanh toán',
        href: '/list-order',
        permission: 'CNPS_SCON_ORDER_PAYMENT_VIEW',
      },
      {
        title: 'Danh sách mã giao dịch',
        href: '/list-transaction-codes',
        permission: 'SCON_RECEIPT_BANK_TRANSACTION_VIEW',
      },
    ],
  },
  {
    icon: 'bx bx-edit',
    title: 'Quản lý KPI',
    accId: 17,
    listPermission: ['CNPS_SUR_PERF_KPI_AGGREGATE_VIEW'],
    child: [
      {
        title: 'Ghi nhận Kpi',
        href: '/kpi-record/list',
        permission: 'CNPS_SUR_PERF_KPI_AGGREGATE_VIEW',
      },
      {
        title: 'Lịch sử upload KPI',
        href: '/kpi-record/upload/history',
        permission: 'CNPS_SUR_PERF_KPI_AGGREGATE_VIEW',
      },
      //KPI sale
      // {
      //   title: 'Cấu hình dịch vụ tính KPI',
      //   href: '/kpi-sale/config/list',
      //   permission: 'CNPS_SUR_PERF_KPI_AGGREGATE_VIEW'
      // },
      // {
      //   title: 'Tổng hợp Phiếu KPI',
      //   href: '/kpi-sale/kpi-order-get-list',
      //   permission: 'CNPS_SUR_PERF_KPI_AGGREGATE_VIEW'
      // },
      // {
      //   title: 'Danh sách KPI tạm tính',
      //   href: '/kpi-sale/kpi-order-tam-tinh',
      //   permission: 'CNPS_SUR_PERF_KPI_AGGREGATE_VIEW'
      // },
      {
        title: 'TPV Merchant',
        href: '/tpv-merchant',
        permission: '',
      },
      {
        title: 'Ghi nhận hoa hồng',
        href: '/kpi-rose',
        permission: '',
      },
    ],
  },
  // {
  //   icon: 'bx bx-buildings',
  //   title: 'Ứng vốn Nextlend',
  //   accId: 9,
  //   listPermission: ['CNPS_CSTM_NEXTLEND_LIST'],
  //   child: [
  //     // {
  //     //   title: 'Khách hàng tiềm năng',
  //     //   href: '/customer-nextlend',
  //     //   permission: 'CNPS_CSTM_NEXTLEND_LIST',
  //     // },
  //     {
  //       title: 'Danh sách ứng vốn',
  //       href: '/equity-nextlend',
  //       permission: 'CNPS_CSTM_NEXTLEND_LIST',
  //     },
  //     // {
  //     //   title: 'Lịch sử tiếp cận',
  //     //   href: '/list-mc',
  //     //   permission: ''
  //     // }
  //   ],
  // },
  {
    icon: 'bx bx-cog',
    title: 'Cài đặt',
    accId: 11,
    listPermission: ['CNPS_CFG_ROLE_LIST'],
    child: [
      {
        title: 'Quyền',
        href: '/role',
        permission: 'CNPS_CFG_ROLE_LIST',
      },
      {
        title: 'Cấu hình Gói dịch vụ/ Thiết bị',
        href: '/device-service-price-config',
        permission: 'CNPS_CFG_PACKAGE_SERVICE',
      },
      {
        title: 'Chính sách thiết bị',
        href: '/policy-device',
        permission: 'CNPS_CFG_VIEW_POLICY',
      },
      {
        title: 'Cấu hình khu vực',
        href: '/config-location',
        permission: 'CNPS_CFG_LOCATION',
      },
      {
        title: 'Thông báo hệ thống',
        href: '/system-notification',
        permission: 'CNPS_CFG_LOCATION',
      },
    ],
  },
  // {
  //   icon: 'bx bx-calendar',
  //   accId: 12,
  //   title: 'Báo cáo',
  //   listPermission: ['CNPS_ATTN_ATTENDANCE_EXPORT', 'CNPS_CSTM_MERCHANT_LIST_XLS', 'CNPS_WKCLDR_EXPORT', 'CNPS_SUMMARY_REPORT_XLS', 'CNPS_DEVICE_REPORT_VIEW'],
  //   child: [
  //     // {
  //     //   title: 'Báo cáo danh sách thiết bị lên hợp đồng',
  //     //   href: '/report-device-contract',
  //     //   permission: 'CNPS_ATTN_ATTENDANCE_EXPORT'
  //     // },
  //     // {
  //     //   title: 'Báo cáo danh sách thiết bị xuất nhập tồn',
  //     //   href: '/report-device',
  //     //   permission: 'CNPS_DEVICE_REPORT_VIEW'
  //     // },
  //     {
  //       title: 'Báo cáo chấm công',
  //       href: '/report-attentdent',
  //       permission: 'CNPS_ATTN_ATTENDANCE_EXPORT'
  //     },
  //     {
  //       title: 'Báo cáo merchant',
  //       href: '/report-merchant',
  //       permission: 'CNPS_CSTM_MERCHANT_LIST_XLS'
  //     },
  //     {
  //       title: 'Báo cáo công việc',
  //       href: '/report-work',
  //       permission: 'CNPS_WKCLDR_EXPORT'
  //     },
  //     {
  //       title: 'Thống kê tổng hợp công việc của CVKD',
  //       href: '/report-work-cvkd',
  //       permission: 'CNPS_SUMMARY_REPORT_XLS'
  //     }
  //   ]
  // },
  {
    icon: 'bx bx-map-pin',
    title: 'Tracking',
    accId: 13,
    href: '/tracking',
    permission: 'CNPS_TKLC_SEARCH',
  },
  {
    icon: 'bx bx-user-circle',
    accId: 14,
    title: 'Marketing',
    listPermission: ['CNPS_WKCLDR_STICKER_STANDEE'],
    child: [
      {
        title: 'Công việc dán Sticker-Standee',
        href: '/sticker-standee',
        permission: 'CNPS_WKCLDR_STICKER_STANDEE',
      },
    ],
  },
  {
    icon: 'bx bxs-user-voice',
    title: 'CSKH',
    accId: 15,
    listPermission: [
      'PERMISSION_OUT_MYNEXTPAY',
      'CNPS_CSS_FILTER_SERVICE',
      'CNPS_CSS_MO_LIST',
      'CNPS_CSS_MA_LIST',
      'CNPS_CSS_FILTER_SERVICE',
      'CNPS_CSS_STORE_LIST',
      'CNPS_CSS_CONTACT_LIST',
      'CNPS_CSS_TASK_LIST',
      'CNPS_CSS_VA_QR_LIST',
      'CNPS_CSTM_MERCHANT_KEY_LIST',
    ],
    child: [
      {
        icon: 'bx bx-sitemap',
        title: 'Merchant key',
        href: '/customer-support/merchant-key',
        permission: 'CNPS_CSTM_MERCHANT_KEY_LIST',
      },
      {
        icon: '',
        title: 'Filter service',
        href: '/customer-support/filter-service',
        permission: 'CNPS_CSS_FILTER_SERVICE',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Quản lý khách hàng ( MO )',
        href: '/customer-support/merchant-owner',
        permission: 'CNPS_CSS_MO_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Quản lý tài khoản ( MA )',
        href: '/customer-support/account',
        permission: 'CNPS_CSS_MA_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Danh sách MC ưu đãi SME',
        href: '/customer-support/mc-sme',
        permission: 'CNPS_CSS_MA_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Quản lý cửa hàng',
        href: '/customer-support/store',
        permission: 'CNPS_CSS_STORE_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Danh sách liên hệ',
        href: '/customer-support/contact',
        permission: 'CNPS_CSS_CONTACT_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Danh sách công việc',
        href: '/customer-support/task',
        permission: 'CNPS_CSS_TASK_LIST',
      },
      {
        title: 'Thông báo chiến dịch',
        href: '/customer-support/task-type-purpose',
        permission: 'CNPS_CALENDAR_WK_TASK_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Doanh số giao dịch MA (TPV)',
        href: '/customer-support/tpv-ma',
        permission: 'CNPS_DFS_REPORT_VIEW_TPV_MA',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Quản lý QR',
        href: '/customer-support/account-qr',
        permission: 'CNPS_CSS_QR_LIST',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Danh sách nhóm người dùng',
        href: '/customer-support/group-user',
        permission: 'CNPS_CSS_ACCESS_TEAM_USER',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Phiếu duyệt chi nhánh',
        href: '/customer-support/order-store',
        permission: 'CNPS_CSS_ORDER_STORE_VIEW',
      },
      // {
      //   icon: 'bx bx-sitemap',
      //   title: 'Task',
      //   href: '/customer-support/task',
      //   permission: 'CNPS_CSS_TASK_LIST'
      // },
      {
        icon: 'bx bx-sitemap',
        title: 'Phiếu duyệt gán',
        href: '/customer-support/assign-order',
        permission: 'CNPS_CSS_ASSIGN_ORDER_LIST',
        // permission: ''
      },
      // {
      //   icon: 'bx bx-sitemap',
      //   title: 'Merchant store',
      //   href: '/customer-support/store',
      //   permission: 'PERMISSION_OUT_MYNEXTPAY'
      // },
      // {
      //   icon: 'bx bx-sitemap',
      //   title: 'Merchant store staff',
      //   href: '/customer-support/store-staff',
      //   permission: 'PERMISSION_OUT_MYNEXTPAY'
      // },
      // {
      //   icon: 'bx bx-sitemap',
      //   title: 'Merchant contact',
      //   href: '/customer-support/contact',
      //   permission: 'PERMISSION_OUT_MYNEXTPAY'
      // },
      // {
      //   icon: 'bx bx-sitemap',
      //   title: 'Merchant contract',
      //   href: '/customer-support/contract',
      //   permission: 'PERMISSION_OUT_MYNEXTPAY'
      // },
      {
        icon: 'bx bx-sitemap',
        title: 'Phiếu luân chuyển thiết bị',
        href: '/customer-support/order-contract',
        permission: 'CNPS_DEVICE_VIEW',
      },
      {
        icon: 'bx bx-sitemap',
        title: 'Quản lý trạng thái sử dụng thiết bị',
        href: '/customer-support/device-store',
        permission: 'CNPS_DEVICE_VIEW',
      },
    ],
  },
  {
    icon: 'bx bx-archive-in',
    title: 'Tích hợp',
    accId: 16,
    listPermission: [
      'CNPS_INTEG_EMAIL_VIEW',
      'CNPS_INTEG_CALLIO_VIEW',
      'CNPS_SUMMARY_FILE_IMPORT',
      // 'PERMISSION_OUT_MYNEXTPAY',
      'CNPS_ATTN_ATTENDANCE_LIST',
    ],
    child: [
      {
        icon: 'bx bx-archive-in',
        title: 'Email gửi cho Merchant',
        href: '/list-email',
        permission: 'CNPS_INTEG_EMAIL_VIEW',
      },
      {
        icon: 'bx bx-archive-in',
        title: 'Cuộc gọi callIO',
        href: '/call-io',
        permission: 'CNPS_INTEG_CALLIO_VIEW',
      },
      {
        icon: 'bx bx-archive-in',
        title: 'Lịch sử upload file',
        href: '/file',
        permission: 'CNPS_SUMMARY_FILE_IMPORT',
      },
      {
        icon: 'bx bx-archive-in',
        title: 'Dự án',
        href: '/projects',
        permission: 'CNPS_ATTN_ATTENDANCE_LIST',
      },
      {
        icon: 'bx bx-archive-in',
        title: 'Đồng bộ dữ liệu Mautic',
        href: '/sync-mautic',
        permission: '',
      },
      {
        icon: 'bx bx-archive-in',
        title: 'Lịch sử upload file Mautic',
        href: '/history-mautic',
        permission: '',
      },
      {
        icon: 'bx bx-archive-in',
        title: 'Cài đặt mật khẩu google app',
        href: '/change-password-google-app',
        permission: 'CNPS_ADMIN_FUNCTION',
      },
    ],
  },
  {
    icon: 'bx bx-cog',
    title: 'Công cụ admin',
    accId: 18,
    listPermission: ['CNPS_ADMIN_FUNCTION'],
    child: [
      {
        icon: 'bx bx-archive-in',
        title: 'Dữ liệu SMS',
        href: '/data-sms',
        permission: 'CNPS_ADMIN_FUNCTION',
      },
    ],
  },
]
